import { useMemo } from 'react';
import { useLatest } from 'react-use';

import { asSequentialAsync } from '../utils/async';

/**
 * React hook version of `asSequentialAsync`. This hook returns an async
 * function that can be invoked multiple times in parallel, but will ensure that
 * the invocations are processed one at a time, in order.
 *
 * NOTE: `fn` must be stable (memoized/constant/similar) since the returned
 * wrapped function is only created once.
 */
const useAsSequentialAsync = (fn) => {
  const fnRef = useLatest(fn); // Wrap in a ref to ensure the useMemo below is only evaluated once
  return useMemo(() => asSequentialAsync(fnRef.current), [fnRef]);
};

export default useAsSequentialAsync;
